import { Resource } from "./resource";

export enum AlertSeverity {
    Info = "Info",
    Warning = "Warning",
    Danger = "Danger",
}

export interface AlertResource extends Resource {
    Severity: AlertSeverity;
    Message: string;
}

export default AlertResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/alertResource.ts